import { AnyAction } from 'redux';

interface User {
    loading: boolean;
}

const initialState: User = {
    loading: false,
};
export const CreateUser = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'NEW_USER':
            return {
                ...state,
            };
        case 'LOADING':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
